import { render, staticRenderFns } from "./VStatusToggler.vue?vue&type=template&id=6ed6956e"
import script from "./VStatusToggler.vue?vue&type=script&lang=js"
export * from "./VStatusToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports